<template>
  <v-row justify="center">
    <v-col class="col-md-6 col-md-offset-3 text-center">
    <p>{{ $t('error_details') }}</p>
    <img :src="`${ASSETS_PREFIX}/404/images/404rocket.svg`" class="image-container" alt="broken rocket">
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      ASSETS_PREFIX: state => state.env.ASSETS_PREFIX,
    })
  },
}
</script>